import React from 'react';
import { Box, Container, Grid, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import ActionCTA from '../../../../sharedcomponents/sweepr-action-cta/ActionCTA';
import { useHistory } from 'react-router-dom';
import { publish } from 'pubsub-js';
import styles from './style';
import { getBannerImage } from './helpCentreBanner.util';

/**
 * @name Banner - Banner component
 * @param {*} props - Strapi cms data
 * @returns {JSX.Element} - Returns Banner Element
 */
const HelpCentreBanner = props => {
    const theme = useTheme();
    const history = useHistory();
    const { bannerMobile, bannerDesktop, bannerTablet, chevron } = getBannerImage(props);
    const classes = styles({ theme, bannerMobile, bannerTablet, bannerDesktop });

    const arrowAction = () => {
        history.push('/account/dashboard');
        publish('openhamburger');
    };
    return (
        <Container className={classes.bannerContainer}>
            <Grid container className={classes.bannerBoxContainer}>
                <Grid item xs={12} sm={12} md={8} lg={7} className={classes.bannerDetails}>
                    {chevron && (
                        <Box
                            className={classes.headerBackArrow}
                            component='img'
                            src={chevron}
                            onClick={arrowAction}
                        />
                    )}
                    <Box className={classes.bannerBox}>
                        <Typography component='h1' variant={'h2'} className={classes.bannerTitle}>
                            {props.cmsData?.title}
                        </Typography>
                        <Typography
                            component='p'
                            variant='body1'
                            className={classes.bannerDescription}
                        >
                            {props.cmsData?.description}
                        </Typography>
                        {props?.cmsData?.Banner_CTAs.length > 0 && (
                            <Box className={classes.bannerCTA}>
                                <ActionCTA
                                    cta={props?.cmsData?.Banner_CTAs}
                                    handleAction={props?.handleAction}
                                />
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

HelpCentreBanner.displayName = 'HelpCentreBanner';
export default HelpCentreBanner;
